@if (activeBlock$()) {
  <div class="blocks-quota__container">
    <div class="blocks-quota__title">
      <span class="blocks-quota__main-title fs__lg fw__500">Distribution Settings</span>
      <span class="blocks-quota__sub-title fs__md">System routes respondents to meet targets after launch</span>
    </div>
    <div class="blocks-quota__content">
      @if (activeBlock$().value.groupedBlockIds?.length < 2) {
        <p class="blocks-quota__content-warning fs__md fw__400">To start adding quotas, the block must have at least two sub-blocks.</p>
      } @else {
        <div class="blocks-quota__content__even-distribution">
          <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" [formControl]="activeBlock$().get('evenDistributionInd') | toFormControl">
            <span class="fs__md fw__600">Even distribution</span>
          </mat-slide-toggle>

          @if (activeBlock$().get('evenDistributionInd').value) {
            <div class="blocks-quota__content__blocks">
              <div class="">
                <span class="label fs__sm fw__600">Number of blocks to show</span>
                <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
                  <mat-select [formControl]="activeBlock$().get('evenDistributionQuantity') | toFormControl" [placeholder]="'Select the number of blocks'">
                    @for (option of numberOfBlocksOptions$(); track option) {
                      <mat-option [value]="option">{{ option }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <button mat-button color="primary" (click)="onShowAdvanceSettings()">
                <span class="fs__sm fw__500">{{ showAdvanceSettings$() ? 'Hide Advanced Settings' : 'Advance Settings' }}</span>
              </button>

              @if (showAdvanceSettings$()) {
                <div class="blocks-quota__content__blocks__quotas">
                  <span class="fs__sm fw__600">Completes per block</span>
                  <div class="blocks-quota__content__blocks__quotas__content">
                    @for (quota of (activeBlock$().get('quotas') | toFormArray).controls; track quota.value) {
                      <div [formGroup]="quota | toFormGroup" class="blocks-quota__content__blocks__quotas__content__input">
                        <div class="list-decoration">
                          <div class="list-decoration-bullet"></div>
                          <div class="list-decoration-empty"></div>
                        </div>
                        <div class="blocks-quota__content__blocks__quotas__content__input__form">
                          <span class="label fs__sm fw__600">{{ quota.get('id').value }} Sub block</span>
                          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
                            <input matInput type="number" [formControl]="quota.get('quota') | toFormControl" autocomplete="off" />
                          </mat-form-field>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
